import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ac12ada"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "overview" }
const _hoisted_3 = { class: "d-flex d-full-w d-full-h" }
const _hoisted_4 = { class: "d-flex-1f d-center d-flex-column van-row--justify-center" }
const _hoisted_5 = { class: "overviewItemValue" }
const _hoisted_6 = { class: "text-xs" }
const _hoisted_7 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_8 = { class: "overviewItemTitle d-flex van-row--align-center van-row--justify-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "邀请志愿者", -1))
const _hoisted_10 = {
  class: "d-flex-1f d-center d-flex-column van-row--justify-center border-lr",
  style: {"margin":"10px 0","box-sizing":"border-box"}
}
const _hoisted_11 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overviewItemTitle" }, "快速找组织", -1))
const _hoisted_13 = { class: "d-flex-1f d-center d-flex-column van-row--justify-center" }
const _hoisted_14 = { class: "overviewItemValue" }
const _hoisted_15 = { class: "text-xs" }
const _hoisted_16 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overviewItemTitle" }, "志愿活动时间", -1))
const _hoisted_18 = { class: "banner" }
const _hoisted_19 = { class: "activeCenterWrap" }
const _hoisted_20 = { class: "titleWrap d-flex van-row--justify-space-between d-flex-h-center" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-lg title" }, "活动中心", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "查看更多", -1))
const _hoisted_23 = { class: "activeContent" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  class: "text-sm",
  style: {"margin-bottom":".4rem"}
}
const _hoisted_26 = { class: "d-flex van-row--justify-space-between" }
const _hoisted_27 = { class: "d-flex van-row--align-center" }
const _hoisted_28 = {
  key: 0,
  class: "text-xs",
  style: {"color":"#909399","padding-left":"0.3rem"}
}
const _hoisted_29 = {
  key: 1,
  class: "text-xs",
  style: {"color":"#909399","padding-left":"0.3rem"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!
  const _component_RatioHeightContainer = _resolveComponent("RatioHeightContainer")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_app_list = _resolveComponent("app-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", null, _toDisplayString(_ctx.formatData().formatUserCount(_ctx.homePage.userCount)[0]), 1),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.formatData().formatUserCount(_ctx.homePage.userCount)[1]), 1),
            (_ctx.homePage.userCount > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "名"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_van_image, {
              class: "banner-item-img-wrapper",
              width: "0.9375rem",
              height: "0.9375rem",
              alt: "图片加载中...",
              fit: "cover",
              src: _ctx.assetImg['star-smile-fill']
            }, null, 8, ["src"]),
            _hoisted_9
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", {
            class: "overviewItemValue",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToFindOrganization && _ctx.goToFindOrganization(...args)))
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.homePage.organizationCount), 1),
            (_ctx.homePage.organizationCount > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, "个"))
              : _createCommentVNode("", true)
          ]),
          _hoisted_12
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("span", null, _toDisplayString(_ctx.formatData().formatToHour(_ctx.homePage.actTime)[0]), 1),
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.formatData().formatToHour(_ctx.homePage.actTime)[1]), 1),
            (_ctx.homePage.actTime > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_16, "小时"))
              : _createCommentVNode("", true)
          ]),
          _hoisted_17
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createVNode(_component_RatioHeightContainer, { ratio: 42.1 }, {
        default: _withCtx(() => [
          _createVNode(_component_van_swipe, {
            class: "banner-wrapper",
            autoplay: 3000,
            "show-indicators": false
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carouseImgs, (item, index) => {
                return (_openBlock(), _createBlock(_component_van_swipe_item, {
                  class: "banner-item",
                  key: index
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_image, {
                      onClick: ($event: any) => (_ctx.goToUrl(item)),
                      class: "banner-item-img-wrapper",
                      width: "100%",
                      height: "100%",
                      alt: "图片加载中...",
                      fit: "cover",
                      src: _ctx.img(item.imgKey)
                    }, null, 8, ["onClick", "src"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("div", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToFindActives && _ctx.goToFindActives(...args))),
          style: {"color":"#909399"},
          class: "text-sm"
        }, [
          _hoisted_22,
          _createVNode(_component_van_icon, { name: "arrow" })
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_app_list, {
          onLoadData: _ctx.loadHomeOrganizeActivitiy,
          ref: "appListRef",
          disabled: true
        }, {
          default: _withCtx(({list}) => [
            _createElementVNode("div", {
              style: _normalizeStyle({height: _ctx.flowHeight[0]>=_ctx.flowHeight[1]?_ctx.flowHeight[0]+'px':_ctx.flowHeight[1]+'px'})
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  ref_for: true,
                  ref: _ctx.setItemRef,
                  class: "activeContentItem",
                  onClick: ($event: any) => (_ctx.goToActivityDescription(item)),
                  key: item.id,
                  style: {"width":"48%"}
                }, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_van_image, {
                      class: "banner-item-img-wrapper",
                      width: "100%",
                      height: "100%",
                      alt: "图片加载中...",
                      radius: 6,
                      fit: "cover",
                      src: _ctx.img(item.img)
                    }, null, 8, ["src"])
                  ]),
                  _createElementVNode("div", _hoisted_25, _toDisplayString(item.name), 1),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["area text-xs", {'visibility-hidden':!item.district}])
                    }, _toDisplayString(item.district), 3),
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_van_image, {
                        class: "banner-item-img-wrapper",
                        width: "0.875rem",
                        alt: "图片加载中...",
                        fit: "cover",
                        src: _ctx.assetImg['contacts-fill']
                      }, null, 8, ["src"]),
                      (item.signupNum != -1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(item.checkInNum) + "/" + _toDisplayString(item.signupNum) + "人", 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(item.checkInNum) + "人", 1))
                    ])
                  ])
                ], 8, _hoisted_24))
              }), 128))
            ], 4)
          ]),
          _: 1
        }, 8, ["onLoadData"])
      ])
    ])
  ]))
}